var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.998 10a.948.948 0 01.651.26.889.889 0 01.27.629v2.963a.874.874 0 01-.27.628.937.937 0 01-.65.26.937.937 0 01-.651-.26.874.874 0 01-.27-.628v-2.963c0-.236.097-.462.27-.629a.937.937 0 01.65-.26z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.919 7.926a.874.874 0 01-.27.628.937.937 0 01-.65.26.937.937 0 01-.651-.26.874.874 0 01-.27-.628c0-.236.097-.462.27-.629a.937.937 0 01.65-.26c.245 0 .479.094.651.26.173.167.27.393.27.629z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.905 13.556l-5.313-8.89a1.81 1.81 0 00-.674-.65 1.89 1.89 0 00-1.84 0 1.81 1.81 0 00-.673.65l-5.313 8.89a1.731 1.731 0 000 1.777c.161.27.393.495.673.65.28.157.597.24.92.24h10.627c.323 0 .64-.083.92-.238a1.8 1.8 0 00.674-.651 1.728 1.728 0 00-.001-1.778zm-3.72-9.778c-1.415-2.37-4.958-2.37-6.372 0l-5.315 8.889C.082 15.037 1.852 18 4.687 18h10.626c2.835 0 4.604-2.963 3.189-5.333l-5.313-8.89h-.003z",
    clipRule: "evenodd"
  })));
}

export default SvgAlert;